import { forwardRef } from 'react';

import { Theme, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { ACTION_BAR_HEIGHT } from './ActionBar';

type StyleProps = { columns: number; topOffset: number };

const useStyles = makeStyles<Theme, StyleProps>(
  theme => ({
    root: {
      position: 'sticky',
      top: ({ topOffset }) => topOffset,
      zIndex: 5,
      background: theme.palette.background.default,
      width: '100%',
      minHeight: ACTION_BAR_HEIGHT,
    },
    content: {
      display: 'grid',
      padding: theme.spacing(2, 0),
      rowGap: theme.spacing(1),
      columnGap: theme.spacing(2),
      alignItems: 'center',
      gridAutoFlow: 'column',
      justifyContent: 'space-between',
      [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-start',
        gridTemplateColumns: ({ columns }) =>
          `${
            columns - 1 !== 0 ? `repeat(${columns - 1}, max-content)` : ''
          } 1fr max-content`,
        '& > *:last-child': {
          gridColumn: -1,
        },
      },
    },
  }),
  { name: 'ActionBarMui' },
);

export const ActionBarMui = forwardRef<
  HTMLDivElement | null,
  React.PropsWithChildren<{ topOffset?: number; className?: string }>
>(({ topOffset, children, className }, ref) => {
  const classes = useStyles({
    columns: Array.isArray(children) ? children.length : 1,
    topOffset: topOffset || 0,
  });

  return (
    <div data-component="ActionBar" className={classes.root} ref={ref}>
      <div className={classNames(classes.content, className)}>{children}</div>
    </div>
  );
});
ActionBarMui.displayName = 'ActionBarMui';
